var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tabsbar" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _vm._l(_vm.tabNames, function (tabName, index) {
          return [
            _c(
              "div",
              {
                key: index,
                staticClass: "tabsbar-title column",
                class: _vm.tabTitleClass(tabName, index),
                on: {
                  click: function ($event) {
                    return _vm.tabClickAction(index)
                  },
                },
              },
              [_vm._v("\n        " + _vm._s(tabName) + "\n      ")]
            ),
          ]
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }